<template>
  <div class="box">
    <van-nav-bar
      safe-area-inset-top
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
      :right-text="txt"
      title="消息通知"
      z-index='10'
      fixed
    />
    <div class="tabs-box-style">
        <van-tabs @click="onClick(active)" v-model="active">
            <van-tab title="我的消息">
                <van-list
                    v-model="loadingMy"
                    :finished="finishedMy"
                    finished-text="没有更多了"
                    @load="onLoadMy"
                >
                    <div v-for="(item,index) in listMy" :key="index" @click="orderClick(item)" class="div-box-style">
                        <van-row>
                            <van-col span="1"></van-col>
                            <van-col class="col-box-style" span="16">
                                <div v-if="item.isRead === '0'" v-show="circle" class="circle-style"></div>
                                <span style="margin-left:10px">{{item.msgTitle}}</span>
                            </van-col>
                            <van-col span="6">
                                <span>{{item.sendTimeStr}}</span>
                            </van-col>
                            <van-col span="1"></van-col>
                        </van-row>
                        <van-row style="margin-top:8px;">
                            <!-- <van-col span="1"></van-col> -->
                            <van-col class="col-box-style" span="22">
                                <span style="margin-left:20px;color:#909090;">
                                    {{item.msgContent}}
                                </span>
                            </van-col>
                            <van-col span="1"></van-col>
                        </van-row>
                    </div>
                </van-list>
            </van-tab>
            <van-tab title="系统公告">
                <div v-show="true" v-for="(item,index) in announcementArr" :key="index" class="div-box-style">
                    <van-row>
                        <van-col span="1"></van-col>
                        <van-col class="col-box-style" span="16">
                            <!-- <div class="circle-style"></div> -->
                            <span style="margin-left:10px">{{item.noticeTitle}}</span>
                        </van-col>
                        <van-col span="6">
                            <span>{{item.noticeReleaseTimeStr}}</span>
                        </van-col>
                        <van-col span="1"></van-col>
                    </van-row>
                    <van-row style="margin-top:8px;">
                        <!-- <van-col span="1"></van-col> -->
                        <van-col class="col-box-style" span="22">
                            <span style="margin-left:20px;color:#909090;">
                                {{item.noticeContent}}
                            </span>
                        </van-col>
                        <van-col span="1"></van-col>
                    </van-row>
                </div>
            </van-tab>
        </van-tabs>
    </div>
  </div>
</template>

<script>
import Api from "../../api/api";
import storeState from '../../store/index'  //storeId就是导出的那个值

export default {
  data() {
    return {
        active: 1, // tabs组件切换
        txt: '全部已读',
        circle: true, // 批量已读显示隐藏
        listMy: [], // 用户消息列表信息
        loadingMy: false, // 加载状态结束
        finishedMy: false, // 数据全部加载完成
        announcementArr:[], // 系统公告列表
        integralData:{
          page: 1, // 当前页码
          rows: 10, // 每页条数
          data:{
            userId:'' // 用户ID
          }
        }
    };
  },
  mounted() {
    this.active = this.$route.query.active * 1;
    if (this.active === 0) {
        this.txt = "全部已读";
    } else {
        this.txt = "";
    }
    this.integralData.data.userId = localStorage.getItem("userId");
    Api.sysNoticeList({}).then((res) => {
      if (res.data.success && res.data.result.length > 0) {
        for(let i=0;i<res.data.result.length;i++){
            res.data.result[i].noticeReleaseTimeStr = res.data.result[i].noticeReleaseTimeStr.substring(0,10);
        }
        this.announcementArr = res.data.result;
        console.log(this.announcementArr);
      }
    });
  },
  methods: {
    // 进入页面加载消息列表(分页)
    onLoadMy() {
      Api.msgQueryPage(this.integralData).then((res) => {
        if (res.data.success) {
            console.log(res);
            this.integralData.page += 1;
            for (let i = 0; i < res.data.result.list.length; i++) {
                this.listMy.push(res.data.result.list[i]);
            }
            // 加载状态结束
            this.loadingMy = false;
            // 数据全部加载完成
            if (this.listMy.length >= res.data.result.totalCount) {
                this.finishedMy = true;
            }
        }
      });
    },
    onClickRight() {
      // 批量设置为已读   
      Api.batchSetUserMsgRead({}).then((res) => {
        console.log(res);
        if (res.data.success) {
            this.circle = false;
        }
      })
    },
    onClick(val) {
        console.log(val);
        if (val == 0) {
            this.txt = '全部已读';
        } else {
            this.txt = '';
        }
    },
    // 跳转配方详情
    orderClick(val) {
        const storeStates = storeState();
        if (val.msgType === '10321001') {
            storeStates.recipeNo = "0E00AE83B8424E2BA6CF48CD3A8F6F16";
            storeStates.recipeQueryType = "2";
            this.$router.push({
                path:'/app-h5-cn/page/orders',
                query: {
                ordId: '3',
                }
            })
        }
    },
    onClickLeft() {
        const storeStates = storeState();
        storeStates.searchShowDiv = true;
        this.$router.push('/app-h5-cn/page/assignWork')
    },
  },
};
</script>

<style lang="scss" scoped>
    .tabs-box-style {
        width: 100%;
        margin-top: 2.9rem;
        // position: fixed;
        .div-box-style {
            width: 100%;
            background-color: #fff;
            padding: 15px 0px;
            margin-top: 15px;
            border-radius: 10px;
            span {
                font-size: 13px;
            }
            .col-box-style {
                display: flex;
                // justify-content: center;
                align-items: center;
            }
        }
    }
    .circle-style {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #F27272;
    }
</style>

<style lang="scss" scoped>
/deep/ .van-nav-bar__title {
  color: black !important;
}
/deep/ .van-nav-bar .van-icon {
  color: black;
}
/deep/ .van-nav-bar__text {
    color: #BABABB !important;
}
// tabs
/deep/ .van-tabs__line {
    width: 50%;
    background-color:#0092FF; //#BCBCBD 100%
}
/deep/ .van-button--round {
        width: 70px;
        font-size: 10px;
        height: 21px;
    }
/deep/ .van-tab--active {
    color: #0092FF ;
}
/deep/ .van-tab {
    font-size: 14px;
}
/deep/ .van-tab__text--ellipsis {
    font-weight: 600;
}
/deep/ .van-tab__pane, .van-tab__pane-wrapper {
    // background-color: #fff;
    width: 92%;
    margin-left: 4%;
    padding-bottom: 20px;
}
</style>